import { type CreateUserInputType } from '@shelflix/schemas/user/create';
import { create } from 'zustand';

interface UserFormStore {
  formData: Partial<
    CreateUserInputType & {
      active?: boolean;
      responsibleUser: {
        uuid: string;
        name: string;
      };
    }
  >;
  setFormData: (
    data: Partial<
      CreateUserInputType & {
        active?: boolean;
        responsibleUser: {
          uuid: string;
          name: string;
        };
      }
    >
  ) => void;
  resetForm: () => void;
}

export const useUserFormStore = create<UserFormStore>((set) => ({
  formData: {},
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
